import Logo from "@/assets/images/brt-logo.png"
import { Box, Button } from "@mui/material"
import React from "react"

const HeaderLogo = () => {
  return (
    <Button
      onClick={() => (window.location.href = "/")}
      sx={{
        p: 0,
        minWidth: "110px",
        "&:hover": { bgcolor: "transparent" },
      }}
    >
      <Box
        component="img"
        src={Logo}
        alt="Braintrust Logo"
        sx={{
          width: { xs: "110px", sm: "130px", md: "150px" },
          height: "auto",
          display: "block",
        }}
      />
    </Button>
  )
}

export default HeaderLogo
